module.exports = __webpack_public_path__ + "static/img/5.5784b01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2019_firefly_TerWeb/3/5.png
// module id = aT8j
// module chunks = 1